import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { ApisService } from 'app/services/apis.service';
import { LoadingService } from 'app/services/loading.service';
import { environment } from 'environments/environment.staging';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.scss'],
      encapsulation: ViewEncapsulation.None,
  
})
export class BranchesComponent implements OnInit {
  constructor(
    private router: Router,
    private translate: TranslateService,
    private apisService: ApisService , 
    private loading : LoadingService , 
    private toastr : ToastrService
  ) {}
  public arrCountries: any[] = [];
  public countryId: any[] = [];

  public arrOrders: any[] = [];
  public basicSelectedOption: number = 10;

  public selectedStatus = [];
  public searchValue = "";
  public ColumnMode = ColumnMode;

  // private
  public tempData = [];
  public tempFilterData;
  public previousStatusFilter = "";

  @ViewChild(DatatableComponent) table: DatatableComponent;

  ngOnInit(): void {
    this.applyLanguage();
    this.getBranches();
  }
  applyLanguage(): void {
    const lang = localStorage.getItem("lang") || "en"; // Default to 'en' if not set
    this.translate.use(lang);
    document.documentElement.lang = lang; // Update <html> tag language attribute

    if (lang === "ar") {
      document.documentElement.dir = "rtl"; // Apply RTL direction for Arabic
    } else {
      document.documentElement.dir = "ltr"; // Apply LTR direction for English
    }
  }

  getBranches() {
    this.loading.show();
    this.apisService.getBranches().subscribe({
      next: (data) => {
        this.loading.hide();
        this.tempData = data.data;  // ✅ because your response is { data: [...] }
      this.arrCountries = this.tempData;

        console.log("Fetched Data:", this.tempData);
      },
      error: (error) => {
        this.loading.hide();
        console.error("API Error:", error);
      },
    });
  }

  filterUpdate(event: any) {
    const val = event.target.value.toLowerCase();
    this.tempData = this.arrOrders.filter((order) =>
      order.name.toLowerCase().includes(val)
    );
  }

  filterByStatus(event) {
    const filter = event ? event.value : "";
    this.previousStatusFilter = filter;
    this.tempFilterData = this.filterRows(filter);
    this.tempData = this.tempFilterData;
  }

  filterRows(statusFilter): any[] {
    if (statusFilter === "") {
      return this.arrOrders;
    } else if (statusFilter === "Other") {
      const mainStatuses = [
        "not set",
        "return",
        "delivered",
        "failed delivery",
      ];
      return this.arrOrders.filter(
        (order) => !mainStatuses.includes(order.delivery_status.toLowerCase())
      );
    }
    return this.arrOrders.filter(
      (order) =>
        order.delivery_status.toLowerCase() === statusFilter.toLowerCase()
    );
  }



  getRowClass = (delivery_status) => {
    return {
      "bg-success": delivery_status == "Delivered",
      "bg-danger": delivery_status == "Failed Delivery",
      "bg-warning": delivery_status == "Return",
      "bg-primary": delivery_status == "Not Set",
      "bg-secondary": ![
        "Delivered",
        "Failed Delivery",
        "Return",
        "Not Set",
      ].includes(delivery_status),
    };
  };


  
  /*----------  Delete Football Entity  ----------*/
  deleteBranches(id:any){ 
this.apisService.deleteBranches(id).subscribe({
  next:(res)=>{
    this.getBranches();
    this.toastr.success(" deleted successfully");
  }, 
  error:(err)=>{
    this.toastr.error("Something went wrong, Please try again later");
  }
})
  }
  

  
  /*----------  getting entity photo  ----------*/
    getFirstImage(postItem): string {
      return postItem?.mediaUrl
        ? environment.mediaUrl + "/" + postItem.mediaUrl
        : // : "assets/images/logo/logo1.svg";
          "assets/images/goalngo/profile.svg";
    }

    
    /*----------  Handling Error in getting Image  ----------*/
    onImageError(event: any) {
      event.target.src = "assets/images/goalngo/profile.svg";
    }
    
  
}
